import { useTranslation } from 'react-i18next';

/** /recruitment/docs — static explanation of the upgrade system (spec §6). */
export function Docs(): JSX.Element {
  const { t } = useTranslation();
  const sections: { h: string; b: string }[] = [
    { h: 'recruitment.docs.treeHeading', b: 'recruitment.docs.treeBody' },
    { h: 'recruitment.docs.oneTimeHeading', b: 'recruitment.docs.oneTimeBody' },
    { h: 'recruitment.docs.monthlyHeading', b: 'recruitment.docs.monthlyBody' },
    { h: 'recruitment.docs.mixedHeading', b: 'recruitment.docs.mixedBody' },
    { h: 'recruitment.docs.combiningHeading', b: 'recruitment.docs.combiningBody' },
  ];
  return (
    <main className="admin-page">
      <header className="admin-page__header">
        <h1>{t('recruitment.docs.title')}</h1>
        <p className="muted">{t('recruitment.docs.intro')}</p>
      </header>
      <section className="admin-card">
        {sections.map((s) => (
          <div key={s.h} className="docs-section">
            <h2 className="admin-card__title">{t(s.h)}</h2>
            <p>{t(s.b)}</p>
          </div>
        ))}
      </section>
    </main>
  );
}
